import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { FileUpload } from "./file-upload";

export const IMAGEUPLOAD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ImageUpload),
  multi: true
};

@Component({
  selector: 'image-upload',
  providers: [IMAGEUPLOAD_VALUE_ACCESSOR],
  template: `
    <div class="imageUploadContainer w-100 w-100 d-flex align-items-center" [ngClass]="{'uploading': uploading }">
    
      <div class="currentImageContainer mr-4">        
        <div *ngIf="file?.url" class="img" [ngStyle]="{'background-image':'url('+file?.url+')'}">
          <img src="{{file?.url}}" class="errorCatcher" (error)="imgLoadError($event)">
        </div>   
        <div *ngIf="!file?.url && placeholder" class="img" [ngStyle]="{'background-image':'url('+placeholder+')'}"></div> 
        
        
        <div class="loading d-flex align-items-center justify-content-center" *ngIf="uploading">
          <ion-spinner></ion-spinner>
        </div>
      </div>
      
      
      <label class="upload">
        <span class="btn btn--ghost" [ngClass]="{'disabled': disabled}">{{ (file) ? changeBtnText:chooseBtnText }}</span>
        <input type="file" name="file" [disabled]="disabled" (change)="uploadFile($event)" accept="image/*"/>
      </label>
      
    </div>`
})
export class ImageUpload extends FileUpload {

  protected fileType: string = 'image';
	@Input() placeholder?: string = null;

  imgLoadError(event){
    this.file.fileName = null;
    // event.target.src = 'assets/icons/user.svg';
  }
    
}


// WEBPACK FOOTER //
// ./src/partials/upload/image-upload.ts